<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="messages.content"
      class="elevation-1 mt-5 pt-3 rounded-card"
      :loading="loading"
      :server-items-length="messages.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhuma mensagem encontrada"
      loading-text="Carregando mensagens..."
      :options="optionsList"
    >
      <template v-slot:item.codigoInterno="{ item }">
        {{ item.codigoInterno | naoInformado }}
      </template>
      <template v-slot:item.mensagem="{ item }">
        <px-show-large-text single-line :large-text="item.mensagem" :truncate-value="100"/>
      </template>
      <template v-slot:item.padrao="{ item }">
        <div class="d-flex justify-center">
          <v-checkbox
            v-model="item.padrao"
            @change="updateMessagePadrao(item)"/>
        </div>
      </template>
      <template v-slot:item.options="{ item }" v-if="hasModuleGerencia">
        <div class="text-right">
          <v-btn icon
                @click="goToEditMessage(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon
                @click="onClickCopy(item)">
            <v-icon>mdi-content-copy</v-icon>
          </v-btn>
          <v-btn icon
                @click="onClickDelete(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MessagesService from '../service/messages-service';

export default {
  props: {
    messages: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
  },
  computed: {
    ...mapGetters('user', ['hasModuleGerencia']),
  },
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Código',
          value: 'codigoInterno',
        },
        {
          text: 'Mensagem',
          value: 'mensagem',
        },
        {
          text: 'Mensagem padrão',
          value: 'padrao',
          align: 'center',
          sortable: false,
        },
        {
          text: null,
          sortable: false,
          align: 'right',
          value: 'options',
        },
      ],
    };
  },
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    remove(item) {
      this.$emit('remove', item);
    },
    goToEditMessage(item) {
      this.$router.push({
        name: 'main.messages.edicao',
        params: {
          id: item.id,
        },
      });
    },
    onClickCopy(item) {
      this.$router.push({
        name: 'main.messages.cadastro',
        params: {
          id: item.id,
        },
        query: {
          isCopy: true,
        },
      });
    },
    onClickDelete(item) {
      this.$refs.confirm.open('Você deseja remover esta mensagem?',
        'A mensagem será removido e esta operação não pode ser desfeita.',
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.remove(item);
        });
    },
    updateMessagePadrao(item) {
      this.loading = true;
      const payload = {
        id: item.id,
        padrao: item.padrao,
      };
      MessagesService.updateMensagemPadrao(payload)
        .then(() => {
          this.$toast('Mensagem atualizada com sucesso', { color: 'success' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
